<i *ngIf="!payrollItems" class="material-icons rotate text-muted">loop</i>
<ng-container *ngIf="payrollItems && payrollItems.length">
  <div class="w-100 text-center mb-2">
    <h5>{{ title ? title : payableType }}</h5>
  </div>
  <div class="payroll-rejection-table-scroll" data-testid="payroll-rejection-table-scroll">
    <p-table styleClass="payroll-rejection-table" [value]="payrollItems" [responsive]="true" [rowTrackBy]="trackByFunction">
      <ng-template pTemplate="header">
        <tr *ngIf="!employeeView">
          <th>
            <div class="payroll-rejection-grid payroll-rejection-grid-header" data-testid="rejection-grid-header">
              <span>Reason</span>
              <span class="payroll-rejection-checkbox-column">Resolved</span>
              <span class="payroll-rejection-checkbox-column">Invalid</span>
            </div>
          </th>
        </tr>
        <tr *ngIf="employeeView">
          <th width="80px">Date</th>
          <th>Time</th>
          <th>Approver Name</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-payrollItem>
        <tr>
          <td [attr.colspan]="employeeView ? 3 : 1">
            <div class="payroll-rejection-item-metadata" [class.payroll-rejection-item-metadata-employee]="employeeView">
              <div>
                <span class="font-weight-bold">Date:</span>
                {{ payrollItem.payableItem.date | date: "shortDate" }}
              </div>
              <div>
                <span class="font-weight-bold">Time:</span>
                {{ payrollItem.payableItem.startTime | date: payrollItem.payableItem.payableTypeID !== 7 ? "shortTime" : "shortDate" }} -
                {{ payrollItem.payableItem.endTime | date: payrollItem.payableItem.payableTypeID !== 7 ? "shortTime" : "shortDate" }}
                ({{ payrollItem.payableItem.timeDiff }})
                <i *ngIf="payrollItem.payableItem.isProductive && payrollItem.payableItem.payableTypeID === 2"
                  class="material-icons" style="color: gold; cursor: default" title="Productive">grade</i>
              </div>
              <div *ngIf="employeeView">
                <span class="font-weight-bold">Approver Name:</span>
                {{ payrollItem.payableItem.approverName }}
              </div>
            </div>

            <div *ngIf="!employeeView" class="payroll-rejection-grid payroll-rejection-grid-row" data-testid="rejection-grid-row">
              <div class="payroll-rejection-reason-column">
                <p-select styleClass="payroll-rejection-reason-select"
                  panelStyleClass="payroll-rejection-reason-panel"
                  appendTo="body" [overlayOptions]="rejectionReasonOverlayOptions"
                  [options]="rejectionReasonOptions"
                  optionLabel="label"
                  optionValue="value"
                  [(ngModel)]="payrollItem.payableItem.selectedRejectionReason"
                  (ngModelChange)="rejectionReasonChanged($event, payrollItem)"
                  placeholder="Select reason..."></p-select>
                <input *ngIf="isOtherSelected(payrollItem)" type="text"
                  class="form-control w-100 mt-2 payroll-other-reason-input"
                  placeholder="Enter custom rejection reason"
                  aria-label="Custom rejection reason"
                  [(ngModel)]="payrollItem.payableItem.reason" (ngModelChange)="changed()"/>
              </div>
              <div class="payroll-rejection-checkbox-column" data-testid="resolved-checkbox-column">
                <p-checkbox [(ngModel)]="payrollItem.payableItem.resolved" binary="true" (onChange)="changed()"></p-checkbox>
              </div>
              <div class="payroll-rejection-checkbox-column" data-testid="invalid-checkbox-column">
                <p-checkbox [(ngModel)]="payrollItem.payableItem.invalid" binary="true" (onChange)="changed()"></p-checkbox>
              </div>
            </div>

            <div *ngIf="employeeView" class="mt-3">
              <span class="d-block font-weight-bold">Reason</span>
              <span class="w-100 mt-2 ml-3">{{ payrollItem.payableItem.reason }}</span>
            </div>

            <div *ngIf="payrollItem.payableItem.response || employeeView" class="mt-3">
              <span class="d-block font-weight-bold">Response</span>
              <span class="w-100 mt-2 ml-3" *ngIf="!employeeView">{{ payrollItem.payableItem.response }}</span>
              <input *ngIf="employeeView" type="text" class="form-control w-100"
                [(ngModel)]="payrollItem.payableItem.response" (ngModelChange)="changed()"/>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <span class="text-right mr-2" *ngIf="!employeeView">Total</span>
        <span *ngIf="!employeeView">{{ totalTime }}</span>
      </ng-template>
    </p-table>
  </div>
</ng-container>
